import React, { useState } from 'react';
import { WidgetCheckListContent } from 'jamespot-user-api';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { JRCModal } from '../../JRCModal/templates/JRCModal';
import { JRCInputTextRaw } from '../../Form/Input/JRCInputTextRaw/JRCInputTextRaw';
import { JRCInputSelectRaw } from '../../Form/Input/JRCSelect/JRCInputSelectRaw';

export const CSSRowLinkWrapper = styled.div<{ border?: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: ${(props) => (props.border ? `1px solid ${props.theme.color.grey2}` : 'none')};
    min-height: 24px;
    border-radius: 4px;
    padding: 4px 8px;
`;

export const JRCWidgetCheckListEditorItemLink = ({
    content,
    idx,
    handleChangeContent,
    closeHandler,
}: {
    content: WidgetCheckListContent;
    idx: number;
    handleChangeContent: (content: WidgetCheckListContent) => void;
    closeHandler: () => void;
}) => {
    const intl = useIntl();
    const [linkValue, setLinkValue] = useState<string>('');
    const [targetOption, setTargetOption] = useState<{ label: string; value: string }>({
        label: intl.formatMessage({ id: 'COMMENT_WIDGET_CHECKLIST_Uri_Same_Page' }),
        value: '_self',
    });

    const handleChange = () => {
        if (idx == -1) {
            return;
        }
        if (!content.arr) {
            return;
        }

        const newContent = {
            ...content,
            arr: [
                ...content.arr.map((task, taskIndex) =>
                    taskIndex === idx
                        ? {
                              ...task,
                              links: task.links
                                  ? [...task.links, { href: linkValue, target: targetOption.value }]
                                  : [{ href: linkValue, target: targetOption.value }],
                          }
                        : task,
                ),
            ],
        };

        handleChangeContent(newContent);
    };

    return (
        <JRCModal
            open={true}
            closeHandler={closeHandler}
            title={intl.formatMessage({ id: 'COMMENT_WIDGET_CHECKLIST_Add_Uri' })}
            buttons={[
                {
                    color: 'cancel',
                    children: intl.formatMessage({ id: 'GLOBAL_Cancel' }),
                    clickHandler: closeHandler,
                },
                {
                    children: intl.formatMessage({ id: 'GLOBAL_Save' }),
                    clickHandler: handleChange,
                },
            ]}
            enableClickAwayCloseModal={false}>
            <label>{intl.formatMessage({ id: 'COMMENT_WIDGET_CHECKLIST_Uri_Link' })}</label>
            <JRCInputTextRaw
                id={'uri'}
                required={true}
                placeholder={intl.formatMessage({ id: 'COMMENT_WIDGET_CHECKLIST_Uri_Link' })}
                type="text"
                onChange={(event) => {
                    const { value } = event.target;
                    setLinkValue(value);
                }}
                margin={'2px'}
                width="100%"
            />

            <label>{intl.formatMessage({ id: 'COMMENT_WIDGET_CHECKLIST_Uri_Target' })}</label>
            <JRCInputSelectRaw
                name="test"
                options={[
                    {
                        label: intl.formatMessage({ id: 'COMMENT_WIDGET_CHECKLIST_Uri_Same_Page' }),
                        value: '_self',
                    },
                    {
                        label: intl.formatMessage({ id: 'COMMENT_WIDGET_CHECKLIST_Uri_New_Page' }),
                        value: '_blank',
                    },
                ]}
                getLabel={(option: { label: string; value: string }) => `${option.label}`}
                getValue={(option: { label: string; value: string }) => `${option.value}`}
                onBlur={() => {
                    /* Nothing to do here */
                }}
                onChange={(e) => {
                    if (e !== targetOption) setTargetOption(e);
                }}
                value={targetOption}
                hideDeleteIcon={true}
            />
        </JRCModal>
    );
};
